<div class="fi-selection-list">
  <div *ngIf="heading" class="fi-selection-list__heading">
    {{ heading }}<span *ngIf="required" class="fi-selection-list__required">&nbsp;*</span>
  </div>

  <div
    class="fi-selection-list__options"
    [class.fi-selection-list__options--horizontal]="alignment === 'horizontal'"
  >
    <ng-content></ng-content>
  </div>

  <div *ngIf="error" class="fi-selection-list__error-text">{{ error }}</div>
</div>
